import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CompliantPresentationLabel } from '@ca/core/models';

@Component({
    selector: 'ca-compliant-badge',
    templateUrl: './compliant-badge.component.html',
    styleUrls: ['./compliant-badge.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CompliantBadgeComponent {
    @Input() presentationType: CompliantPresentationLabel;
}
